import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.37 4.497a.63.63 0 0 1 .63.63v5.218a.63.63 0 0 1-.63.63H3.63a.63.63 0 0 1-.63-.63V5.127a.63.63 0 0 1 .63-.63h16.74Zm-.63 1.26H4.26v3.958h15.48V5.757Zm1.076 7.453a.63.63 0 0 1 .184.445v5.218a.63.63 0 0 1-.63.63H8.117a.63.63 0 0 1-.63-.63v-5.218a.63.63 0 0 1 .63-.63H20.37a.63.63 0 0 1 .446.185Zm-1.075 1.075H8.746v3.958h10.995v-3.958Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=NestedSubItemIcon24.js.map